// Auto-generated translation for bg.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:25:47.979670+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "За собственици на коне",
    title: "Всичко за твоя кон. В едно приложение.",
    subtitle: "Управлявай здравето, тренировките, планирането и специалистите от едно прегледно досие.",
    primaryCTA: {
      label: "Започни безплатно",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Разгледай Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Профил на кон — тегло, ваксинация, EquiCoach, хранене и тренировки в един екран",
      caption: "Твоят кон, напълно прегледен.",
    },
    problem: "Вероятно в момента следиш срещите, снимките, тренировките, храненето и здравето на различни места — в WhatsApp групи, кутии с документи и отделни приложения. Така губиш прегледността.",
    solution: "EquiSight превръща твоя кон в едно пълно цифрово досие, което те придружава навсякъде.",
    benefits: [
      "Едно пълно профилно досие за всеки кон",
      "Здраве, ковач, зъболекар и физиотерапевт на едно място",
      "Календар с умни напомняния",
      "Снимки, бележки и история без ограничение",
      "Резервно копие на всички твои данни при Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 кон · винаги безплатно",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Няколко коня + резервно копие",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Готов ли си да започнеш?",
      title: "Започни днес с твоя първи кон.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Повече коне. Повече прегледност. Повече сигурност.",
    subtitle: "Надградете до Premium и управлявайте всичките си коне без ограничения — с пълната интелигентност на EquiCoach.",
    primaryCTA: {
      label: "Започнете 14 дни безплатно",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Всички цени",
      href: "/#pricing",
    },
    audience: "За собственици, спортни ездачи и коневъди с повече от един кон.",
    features: [
      "Добавяйте неограничен брой коне",
      "Пълна история за всеки кон",
      "Архивиране на данни",
      "Разширени прозрения от EquiCoach",
      "Интелигентни известия и планиране",
      "Здраве и тренировки — напълно свързани",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "По-малко от €0,17 на ден",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Готови ли сте?",
      title: "Надградете до Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "За манежни ездачи",
    title: "Напредвай, дори без собствен кон.",
    subtitle: "Следи своите уроци, тренировки и развитие в EquiSight — за по-малко от цената на кафе на месец за мама или татко. Или за един хубав сладолед с разбита сметана.",
    primaryCTA: {
      label: "Започни с Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Как работи?",
      href: "#features",
    },
    problem: "Като манежен ездач често нямаш собствен кон, но все пак искаш да се развиваш и да имаш преглед на своите уроци, цели и конете, на които яздиш.",
    solution: "Манежната функционалност е включена стандартно в Premium — следи своето развитие и преглеждай свързаните манежни коне в режим само за четене.",
    features: [
      "Проследяване на тренировки",
      "Поставяне на цели",
      "Следене на напредъка",
      "Преглед на манежните коне с име и снимка",
      "Без достъп до лични здравни данни",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "На месец · манежната функционалност е включена",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Стани член",
      title: "Започни като манежен ездач.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "За манежи и конюшни",
    title: "Направете своя манеж дигитално достъпен за всеки ездач.",
    subtitle: "Дайте на ездачите връзка с коне, уроци и напредък — без да споделяте чувствителни данни от конюшнята.",
    primaryCTA: {
      label: "Заявете достъп",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Вижте модулите",
      href: "#features",
    },
    audience: "EquiSight помага на манежи и конюшни да задържат ездачите по-дълго ангажирани и да се откроят дигитално.",
    features: [
      "Правене на манежните коне видими за ездачите",
      "Име и снимка за всеки кон",
      "Свързване на ездачи с коне",
      "Достъп само за четене за чувствителни лични данни",
      "Централизирана история на уроци и тренировки",
      "Управление на потребители с роли",
    ],
    benefits: [
      "По-голяма ангажираност на ездачите",
      "По-професионален облик",
      "Допълнителна дигитална услуга за членове",
      "Нов поток от приходи чрез използване на приложението",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "На месец · функционалността за манеж е включена за ездачите",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Готови ли сте?",
      title: "Активирайте модула за манеж.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Модул за развъждане",
    title: "Контрол върху цикъла, бременността и развитието на жребчето.",
    subtitle: "Пълният модул за развъждане за собственици на кобили и развъдчици — от покриване до жребче, в една времева линия.",
    primaryCTA: {
      label: "Активирай модул за развъждане",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Разгледай функциите",
      href: "#features",
    },
    audience: "За развъдчици, собственици на кобили и конюшни, управляващи множество кобили.",
    features: [
      "Проследяване на цикъла",
      "Регистриране на разгоненост",
      "Записване на дати за осеменяване",
      "Обратно броене до ехографии",
      "Планиране на проверки на бременността",
      "Родословно дърво и произход",
      "Развитие на жребчето",
      "Преглед на всички бременни кобили",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "На месец · Модулът за развъждане е включен в Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Започни днес",
      title: "Започни с управление на развъждането.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Модул Ковач",
    title: "Работете по-умно като ковач. Документирайте всичко професионално.",
    subtitle: "Дневник, снимки, бележки и история на лечението в един модул — по-малко недоразумения, по-силно досие.",
    primaryCTA: {
      label: "Започнете като ковач",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Вижте Professional пакета",
      href: "/professional",
    },
    audience: "За ковачи, които искат да подобрят прегледността, доказателствената база и комуникацията с клиенти.",
    features: [
      "Личен дневник",
      "Срещи по клиент",
      "Преглед на профили на коне",
      "Добавяне на снимки преди и след",
      "Записване на лечението",
      "Регистриране на съвети и бележки",
      "ETA известие до клиента: \"Ковачът е на път\"",
    ],
    benefits: [
      "По-професионална работа",
      "По-малко недоразумения",
      "По-добро изграждане на досие",
      "По-силна позиция при отговорност",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "На месец · Модул Ковач е включен в Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Готови ли сте?",
      title: "Активирайте модул Ковач.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Модул Зъболекар",
    title: "Пълно дентално досие за всеки кон.",
    subtitle: "Регистрирайте находки, лечения и проследяване директно в EquiSight.",
    primaryCTA: {
      label: "Започнете като коски зъболекар",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Вижте Professional пакета",
      href: "/professional",
    },
    audience: "Коски зъболекари, ветеринари и практики, които искат да работят структурирано.",
    features: [
      "Регистриране на зъбен преглед",
      "Находки по лечение",
      "Добавяне на снимки",
      "Доклад до собственика",
      "Съвети за проследяване",
      "История по кон",
      "Планиране на нова среща",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "На месец · Модулът Зъболекар е включен в Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Готови ли сте?",
      title: "Активирайте модула Зъболекар.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Физио / Остео модул",
    title: "Проследявайте тялото, движението и възстановяването по професионален начин.",
    subtitle: "За физиотерапевти и остеопати, които искат да наблюдават конете системно.",
    primaryCTA: {
      label: "Започнете като физио/остео",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Вижте Professional пакета",
      href: "/professional",
    },
    features: [
      "Прием за всеки кон",
      "Регистриране на телесни находки",
      "Добавяне на снимки и видеа",
      "Изготвяне на доклад за лечение",
      "Споделяне на упражнения и проследяване",
      "Следене на процеса на възстановяване",
      "История за всеки кон",
    ],
    benefits: [
      "По-добра представа с течение на времето",
      "Професионална отчетност",
      "Ясна комуникация със собственика, треньора и ездача",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "На месец · Физио / Остео модулът е включен в Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Готови ли сте?",
      title: "Активирайте Физио / Остео модула.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Модул Треньор",
    title: "Обучавай ездачи с данни, цели и напредък.",
    subtitle: "Направи тренировките измерими и наставничеството по-професионално — за един или повече ездачи.",
    primaryCTA: {
      label: "Започни като треньор",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Разгледай Pro пакета",
      href: "/#pricing",
    },
    audience: "За инструктори, треньори и коучове с множество ездачи или коне.",
    features: [
      "Свързване на ездачи",
      "Проследяване на коне",
      "Задаване на тренировъчни цели",
      "Даване на обратна връзка",
      "Анализ на резултати от състезания",
      "Преглед на напредъка по комбинация",
      "Използване на анализи на протоколи за тренировъчен фокус",
    ],
    benefits: [
      "По-добро наставничество",
      "По-голяма структура",
      "По-професионална комуникация",
      "По-силна връзка с клиентите",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "На месец · Модул Треньор е включен в Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Готов?",
      title: "Активирай Модул Треньор.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Анализ на състезания",
    title: "От протокол към подобрение на представянето.",
    subtitle: "Качи своя състезателен протокол и открий къде губиш точки — не само разглеждай резултата си, но разбери как да станеш по-добър.",
    primaryCTA: {
      label: "Анализирай първия си протокол",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Разгледай Premium",
      href: "/premium",
    },
    features: [
      "Качване на снимка на протокол",
      "Обработка на предна и задна страна",
      "Разпознаване на клас, номер на теста и съдия",
      "Анализ на резултатите по елементи",
      "Обобщаване на коментари",
      "Показване на силни и слаби страни",
      "Тенденции по комбинация кон-ездач",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "На месец · анализ на състезания включен от Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Готов?",
      title: "Започни с анализ на състезания.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional пакет",
    title: "За професионалистите около коня.",
    subtitle: "Ковач, зъболекар, физиотерапевт, остеопат или треньор: работете заедно в едно цифрово досие на коня.",
    primaryCTA: {
      label: "Започнете като професионалист",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Вижте отделните модули",
      href: "#features",
    },
    audience: "Professional пакетът комбинира всички специализирани модули в един абонамент.",
    features: [
      "Модул Ковач",
      "Модул Зъболекар",
      "Модул Физио / Остео",
      "Календар и управление на клиенти",
      "Профили на коне и отчети",
      "История на лечението и изграждане на досие",
      "Комуникация със собственика",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "На месец · всички специализирани модули включени",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Готови ли сте?",
      title: "Изберете Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Спешни номера за кон",
    title: "Винаги правилната помощ на една ръка разстояние.",
    subtitle: "При спешен случай всяка секунда е важна. С EquiSight имаш всички важни данни за контакт с твоя кон веднага под ръка — едно докосване и се обаждаш.",
    primaryCTA: {
      label: "Подготви своите спешни контакти",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Започни безплатно с EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Спешни контакти — обади се директно, изпрати WhatsApp или навигирай до ветеринар, клиника и ковач",
      caption: "Едно докосване. Без паника и търсене.",
      embeddedFrame: true,
    },
    problem: "Нещо се случи с коня ти — колики, наранявания, паника. И тогава започва търсенето. Кого да обадиш? Имаш ли правилния номер? Това спешен номер ли е? Ценно време се губи.",
    solution: "С EquiSight имаш всичко веднага под ръка. Без търсене. Без колебание. Едно докосване и си в контакт.",
    scenario: {
      title: "Представи си — конят ти показва симптоми на колики.",
      steps: [
        "Отваряш EquiSight",
        "Натискаш \"Ветеринар\"",
        "Обаждаш се директно",
      ],
      tagline: "Без стрес. Без търсене. Само действие.",
    },
    features: [
      "Всички спешни номера на едно място",
      "Обаждане с едно докосване от приложението",
      "WhatsApp с едно докосване",
      "Директна навигация до адреса",
      "Отделен списък с контакти за всеки кон",
      "Ветеринар, клиника, ковач, зъболекар, физиотерапевт",
      "Адрес и упътване веднага налични",
      "Маркирай любими номера със звезда",
      "Спешни номера (112, 144) винаги най-отгоре",
    ],
    benefits: [
      "Спокойствие и контрол при спешна ситуация",
      "Всички в конюшнята имат едни и същи номера под ръка",
      "Никога повече забравени визитки",
      "Реагирай с секунди по-бързо при спешност",
    ],
    audience: "За собственици на коне, гледачи, треньори и конюшни — всеки, който е отговорен за кон.",
    showcase: {
      eyebrow: "Предварително настроено за теб",
      title: "13 категории контакти — готови за попълване.",
      description: "От ветеринар и спешна клиника до седлар, инструктор и управител на пасище. EquiSight познава твоя свят и подготвя правилните полета за контакти предварително. Докосни, попълни, готово.",
      bullets: [
        "Спешност и здраве — ветеринар, спешен случай, клиника, линия за отравяния",
        "Ежедневни грижи — ковач, зъболекар, физиотерапевт, инструктор",
        "Конюшня и пасище — стопанин на конюшня, управител на пасище, пансион",
        "Храна и материали — доставчици на сено, концентрирани фуражи, слама",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Екран за управление на спешни контакти — всички предложени контакти по категория",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Контролен списък с спешни номера за кон",
      items: [
        "Ветеринар",
        "Спешна клиника (24/7)",
        "Ветеринарна линейка · 144",
        "Ковач",
        "Резервно лице за контакт",
        "Общ номер за спешни случаи · 112",
      ],
      cta: {
        label: "Отвори в EquiSight и попълни веднага",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Спешни номера",
          price: "Gratis",
          note: "Винаги безплатно · за всеки, при всеки абонамент",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Увери се, че си подготвен",
      title: "Преди да се наложи.",
      href: "/#waitlist",
    },
    microcopy: [
      "Без задължения",
      "Настройва се за 2 минути",
      "Винаги може да се промени",
    ],
  },
};

export default LANDINGS;
